const getters = {
  // 注意引入的路径是每个模块下的data
  userinfo: (state) => state.user.userinfo,
  token: (state) => state.user.token,
  dialog: (state) => state.user.dialog,
};
export default getters;
